import { Link } from 'react-router'
import { AnalyticsUtils } from 'utils'
import { QuestionIcon, SimpleCard, HelpEmail, Button, Notice } from 'components'
import { Analytics } from 'common-frontend'

import { List, ListItem } from 'material-ui/List'
import Subheader from 'material-ui/Subheader'
import Avatar from 'material-ui/Avatar'
import Check from 'material-ui/svg-icons/navigation/check'
import Arrow from 'material-ui/svg-icons/hardware/keyboard-arrow-right'
import Close from 'material-ui/svg-icons/navigation/close'
import Launch from 'material-ui/svg-icons/action/launch'
import PriorityHigh from 'material-ui/svg-icons/notification/priority-high'
import { Enum } from 'utils'
import FontIcon from 'material-ui/FontIcon'

import './checks.scss'

export default class extends React.Component {
  static propTypes = {
    checks: React.PropTypes.object.isRequired,
  }

  static contextTypes = {
    muiTheme:    React.PropTypes.object.isRequired,
    router:      React.PropTypes.object.isRequired,
    currentUser: React.PropTypes.object,
  }

  isNewUser() {
    // Used for A/B testing only
    return new Date('2019-07-31') < new Date(this.context.currentUser.createdAt)
  }

  componentWillReceiveProps(newProps) {
    newProps.checks.forEach((check) => {
      const isException = check.get('executeResult') === 'Exception'
      const oldCheck = this.props.checks.find((oldCheck) => oldCheck.get('name') == check.get('name'))
      const wasPreviouslyNotException = !oldCheck || oldCheck.get('executeResult') !== 'Exception'

      if (isException && wasPreviouslyNotException) {
        AnalyticsUtils.errorViewed(this.context.currentUser.email, check.get('exception'))
      }
    })
  }

  renderKnowledgeBase() {
    const knowledges = [
      { title: 'What are good headings <h1> and subheadings <h2>?', link: 'https://support.pluginuseful.com/hc/en-us/articles/23534805888148-What-are-good-headings-h1-and-subheadings-h2-h3-h4' },
      { title: 'How do I know if my SEO is improving or getting worse?', link: 'https://support.pluginuseful.com/hc/en-us/articles/23534779152404-How-do-I-know-If-my-SEO-is-improving-or-getting-worse' },
      { title: 'How can I improve my keyword ranking? The demand-driven SEO technique', link: 'https://support.pluginuseful.com/hc/en-us/articles/23534764435220-How-can-I-improve-my-keyword-ranking-The-demand-driven-SEO-technique' }
    ]

    const viewMoreLink = this.context.currentUser.activeCharge ?
      'https://support.pluginuseful.com/' :
      'https://support.pluginuseful.com/'

    return (
      <SimpleCard title="Knowledge Base" className="large-spacing--top knowledge">
        <div className="knowledge__container body1">
          <div className="knowledge__list">
            {knowledges.map((k, index) => (
              <a href={k.link} target="_blank" key={`k-${index}`} className="knowledge__item">
                <Launch color="#5750C5" />
                <span className="knowledge__item__title">{k.title}</span>
              </a>
            ))}
          </div>
          <div className="knowledge__action large-spacing--top">
            <a href={viewMoreLink} target="_blank">
              <Button
                label="View more"
                buttonType="secondary"
              />
            </a>
          </div>
        </div>
      </SimpleCard>
    )
  }

  renderSupportCard() {
    return (
      <SimpleCard title="Support" className="large-spacing--top">
        <div className="support__container body1">
          <p className="medium-spacing2--bottom">
            Have any questions? We're happy to help.
          </p>
          <p>
            Email us at <HelpEmail />
          </p>
        </div>
      </SimpleCard>
    )
  }

  renderNormal() {
    let listItems = this.props.checks.map((check, i) => {
      if (check.get('onlyForPlus') && !this.context.currentUser.activeCharge) return null

      return (
        <ListItem
          key={i}
          primaryText={<h3 className="checks__label">{check.get('name')}</h3>}
          secondaryText={<p className="checks__verdict foreground-black">{this.getVerdict(check)}</p>}
          rightIcon={<Arrow style={{top: 22}}/>}
          leftIcon={this.leftIcon(check.get('enabled'), check.get('verdictFriendly'), check.get('executeResult'))}
          onTouchTap={ () => { this.context.router.push(this.checkLink(check)) } }
          innerDivStyle={{paddingBottom: 20, paddingLeft: 60}}
        />
      )
    }).toJS() // warning: without .toJS it works in Chrome but no other browsers

    return (
      <div>
        <SimpleCard title="Checks">
          <List className="checks__list">
            {listItems}
          </List>
        </SimpleCard>
        {this.renderKnowledgeBase()}
        {this.renderSupportCard()}
      </div>
    ) 
  }

  renderFree() {
    return (
      <div>
        <SimpleCard title="Checks">
          <List className="checks__list">
            {this.props.checks.map((check, i) => {
              if (check.get('onlyForPlus') && !this.context.currentUser.activeCharge) return null
              if (check.get('key') === 'speed') return null

              return (
                <ListItem
                  key={i}
                  primaryText={<h3 className="checks__label">{check.get('name')}</h3>}
                  secondaryText={<p className="checks__verdict foreground-black">{this.getVerdict(check)}</p>}
                  rightIcon={<Arrow style={{top: 22}}/>}
                  leftIcon={this.leftIcon(check.get('enabled'), check.get('verdictFriendly'), check.get('executeResult'))}
                  onTouchTap={ () => { this.context.router.push(this.checkLink(check)) } }
                  innerDivStyle={{paddingLeft: 60}}
                />
              )
            })}
          </List>
        </SimpleCard>
        {this.renderKnowledgeBase()}
        {this.renderSupportCard()}
      </div>
    )
  }

  render() {
    return this.isNewUser() ? this.renderFree() : this.renderNormal()
  }

  setupCheckLink(check) {
    return `/checks/setup/${check.get('key')}`
  }

  viewCheckLink(check) {
    return `/checks/${check.get('key')}`
  }

  checkLink(check) {
    const needsKeywords = check.get('key') === 'seoproblems' &&
      (!check.get('keywords') || check.get('keywords').toJS().length === 0)

    if (needsKeywords) return this.setupCheckLink(check)

    if (check.get('enabled') && (check.get('executeResult') == 'Success'))
      return this.viewCheckLink(check)
    else
      return this.setupCheckLink(check)
  }

  leftIcon(enabled, verdict, executeResult) {
    let palette = this.context.muiTheme.palette

    let icon = 
      <FontIcon
        className="material-icons"
        style={{ color: palette.foregroundGrey, fontSize: 36 }}
      >
        remove_circle_outline
      </FontIcon>

    if (enabled && executeResult === 'Success') {
      if (verdict && verdict.length > 0)
        verdict = verdict.toLowerCase()

      if (verdict == 'worthwhile to fix') {
        icon  = 
          <FontIcon
            className="material-icons"
            style={{ color: palette.red, fontSize: 36 }}
          >
            clear
          </FontIcon>
      }
      else if (verdict == 'maybe worthwhile to fix') {
        icon =
        <FontIcon
          className="material-icons"
          style={{ color: palette.yellow, fontSize: 36 }}
        >
          warning
        </FontIcon>
      }
      else if (verdict == 'nothing to fix!' || verdict == 'nothing worthwhile to fix') {
        icon =
        <FontIcon
          className="material-icons"
          style={{ color: palette.green, fontSize: 36 }}
        >
          check
        </FontIcon>
      }
    }

    return (
      <div style={{height: 48, width: 36, marginTop: 10}}>
        {icon}
      </div>
    )
  }

  getVerdict(check) {
    if (check.get('enabled') === false) return 'Inactive: Press to enable'

    if (check.get('executeResult') === null) return 'checking...'
    if (check.get('executeResult') === 'Success') return check.get('verdictFriendly')

    return 'Errored: Press to set up'
  }
}



// WEBPACK FOOTER //
// ./app/components/checks/Checks.js